import CompanyTopView from './CompanyTopView';

export default CompanyTopView;
